<template>

    <v-modal :title="`Delete ${count}`">
        <template #body>
            <v-alert :message="error" />
            <p>Are you sure you want to delete {{ count.toLowerCase() }}? This action cannot be undone.</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" btn-style="danger" :loading="loading" @click.native="deleteCustomers">Delete Customers</v-button>
        </template>
    </v-modal>

</template>

<script>

import CompanyApi from '@api/CompanyApi'
import ProjectApi from '@api/ProjectApi'

export default {

    props: {
        ids: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    computed: {

        count() {
            return this.ids.length === 1 ? '1 Customer' : this.ids.length + ' Customers';
        }

    },

    methods: {

        deleteCustomers() {
            this.loading = true;
            ProjectApi.deleteCustomers(this.project.id, { ids: this.ids })
                .then((response) => {
                    this.loading = false;
                    this.$emit('deleted');
                    this.$store.commit('setAlertSuccess', this.$t('message.deleted'));
                    this.$store.commit('showModal', false);
                    CompanyApi.getCompany(this.$store.getters.company.id);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
